export default __webpack_public_path__ + "static/media/turkgot-screenshot-05.b10dd057.png";